<template>
  <section class="section has-background-image has-background-primary-light is-centered">
    <div class="container">
      <div class="columns is-desktop is-vcentered">
	<div class="column is-half ">
	  <InfoBox />	  
	</div>
  <div class="column is-half ">
        <form @submit.prevent="gotoSearch">
          <b-field>
            <b-input
              v-model="queryTerm"
              :expanded="true"
              :placeholder='$t("Search...")'
              type="search"
              icon="search"
            ></b-input>
            <p class="control">
              <b-button type="is-primary" @click="gotoSearch">{{ $t("Search") }}</b-button>
            </p>
          </b-field>
        </form>
	</div>
      </div>
    </div>
  </section>
</template>

<style>
 .has-background-image {
   background-image: url('~@/assets/background.jpg');
   background-repeat: no-repeat;
   /* background-size: cover; */
   background-position: top center;
   position: relative;
 }
 .is-centered {
  display: flex;
align-items: center;
}
</style>

<script>
 import InfoBox from '@/components/InfoBox.vue'

 import { createMapper } from '@/utils/mapping.js'
 const mapper = createMapper('search-form')

 export default {
   components: {
     InfoBox
   },
   computed: {
     query() {
       return mapper.toURL({ term: this.term })
     },
     searchQuery() {
      return mapper.toURL({
        term: this.queryTerm,
      });
    },
    searchPageRoute() {
      // FIXME: use from global definition
      return {
        name: "Search",
        query: this.searchQuery,
      };
    },
   },
   data() {
     return { term: '', queryTerm: '' }
     
   },
   methods: {
    gotoSearch() {
      this.$router.push(this.searchPageRoute);
    },
  },
 }
</script>
